import React from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
const componentName = "InventoryLevel";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label}
                    hintText={LOOKUP.report.common.endDate.label}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
            <BranchSelectAutoCompleteInput
                                    name={componentName + LOOKUP.report.common.branchName}
                                    label={LOOKUP.report.common.branch + "*"}
                                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <AutoCompleteInput
                    name={`${componentName}ProductId`}
                    floatingLabelText={"Search an existing product"}
                    label="Search an existing product"
                    hintText="Product"
                    className={"AutoCompleteInput-searchbar"}
                    fullWidth={false}
                    options={props.products}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label="Download Inventory Data"
                    onTouchTap={props.downloadInventory}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText mt-2'><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders will be used in this report.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
